import { apiClient } from './client'

export interface ProjectAccessMember {
  userId: number
  username: string
  email: string
  projectRole: string
}

export interface ProjectAccessEntry {
  projectId: number
  name: string
  members: ProjectAccessMember[]
}

export async function getProjectAccess(orgId?: number): Promise<ProjectAccessEntry[]> {
  const params = orgId != null ? `?orgId=${orgId}` : ''
  return apiClient.get<ProjectAccessEntry[]>(`/admin/project-access${params}`)
}

export async function addProjectMember(
  projectId: number,
  data: { userId: number; projectRole: string }
): Promise<void> {
  await apiClient.post(`/projects/${projectId}/members`, data)
}

export async function removeProjectMember(projectId: number, userId: number): Promise<void> {
  await apiClient.delete(`/projects/${projectId}/members/${userId}`)
}
